





























































import { Vue, Prop, Component } from 'vue-property-decorator'
@Component({})
export default class Collocation extends Vue {
  @Prop({ default: {} }) collocationInfo: any
  @Prop() curSkuId: number
  @Prop({ default: false }) showProgress: boolean
  @Prop({ default: false }) aloneTitle: boolean
  @Prop({ default: false }) showMore: boolean
  @Prop() maxGoods: number
  @Prop() backgroundGray: string
  backgroundGrayFlag: boolean = false
  progress: any = {
    width: 0,
    left: 0,
  }

  get progressStyle() {
    return {
      width: `${this.progress.width * 100}%`,
      left: `${100 * this.progress.left}%`,
    }
  }

  get isDiscount() {
    return this.collocationInfo.preferential_type === 'discount'
  }

  get goodsList() {
    return this.maxGoods
      ? this.collocationInfo.goodsList.slice(0, this.maxGoods)
      : this.collocationInfo.goodsList
  }

  get isVipgoods() {
    return (this.goodsList || []).filter(el => el.vip_price).length
  }
  get mato40() {
    // console.log('我是啦啦啦啦啦',this.$route)
    if (!this.$route.query['f_r_o_m']) {
      return true
    } else {
      return false
    }
  }
  created() {
    console.log(this.backgroundGray)
    if (this.backgroundGray === '详情页') {
      this.backgroundGrayFlag = true
    }
  }
  mounted() {
    this.scrollListen()
  }

  toCollocationList() {
    this.$emit('toCollocationList')
  }
  toDetail() {
    this.$emit('toDetail', this.collocationInfo.id)
  }

  scrollListen() {
    if (!this.showProgress) return
    let l = this.goodsList.length
    this.progress = {
      width: 3 / l,
      left: 0,
    }
    if (l > 3) {
      let goods: any = this.$refs['collocation-goods']
      goods.addEventListener('scroll', this.scrollFn)
    }
  }
  scrollFn(e) {
    let { scrollLeft: s, offsetWidth: w, scrollWidth: tw } = e.target
    this.progress = {
      width: Math.min(w / tw, 1),
      left: Math.min(s / tw, 1),
    }
  }
  beforeDestory() {
    let goods: any = this.$refs['collocation-goods']
    goods.removeEventListener('scroll', this.scrollFn)
  }
}
